module.exports = __webpack_public_path__ + "static/media/vivoV17Pro.abeb0897.jpeg";